export default Object.freeze({
  AVERAGE: 'average',
  SMALL: 'small',
});
